"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformPolicyApi = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const ResourcesApi_1 = require("./commons/ResourcesApi");
/**
 * Operations for policies.
 */
class SdPlatformPolicyApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "policies";
    }
    /**
     * The platform policy api.
     * @param body {@see SdPlatformPolicyQueryParameters} query body.
     * @returns the {@link SdPlatformQueryResponse} with {@link SdPlatformResponsePolicy} as response.
     */
    query(body = {}) {
        return super.__query(SdPlatformRequestId_1.RequestId.PolicyQuery, body);
    }
    /**
     * Get information about a policy based on its id or alias
     * @param id_or_alias - id or an alias.
     * @returns the {@link SdPlatformGetResponse} with {@link SdPlatformResponsePolicy} as response.
     */
    get(id_or_alias) {
        return super.__get(SdPlatformRequestId_1.RequestId.PolicyGet, id_or_alias);
    }
    /**
     * Creates a platform policy.
     * @param body {@link SdPlatformRequestPolicyCreate}
     * @returns the {@link SdPlatformPostResponse} with {@link SdPlatformResponsePolicy} as response.
     */
    create(body) {
        return super.__post(SdPlatformRequestId_1.RequestId.PolicyCreate, body);
    }
    /**
     * Updates a platform policy.
     * @param id - the policy id.
     * @param body {@link SdPlatformRequestPolicyPatch} of patch request.
     * @returns the {@link SdPlatformPatchResponse} with {@link SdPlatformResponsePolicy} as data parameter.
     */
    patch(id, body) {
        return this.__patch(SdPlatformRequestId_1.RequestId.PolicyPatch, id, body);
    }
    /**
     * Deletes the policy
     * @param id - the policy id.
     * @returns the {@link SdPlatformDeleteResponse}
     */
    delete(id) {
        return this.__delete(SdPlatformRequestId_1.RequestId.PolicyDelete, id);
    }
}
exports.SdPlatformPolicyApi = SdPlatformPolicyApi;
//# sourceMappingURL=SdPlatformPolicyApi.js.map